import { render, staticRenderFns } from "./drawerDocumentiDettaglio.vue?vue&type=template&id=bb59bece"
import script from "./drawerDocumentiDettaglio.vue?vue&type=script&lang=js"
export * from "./drawerDocumentiDettaglio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports